import { render, staticRenderFns } from "./quan.vue?vue&type=template&id=db2ca6c4&scoped=true"
import script from "./quan.vue?vue&type=script&lang=js"
export * from "./quan.vue?vue&type=script&lang=js"
import style0 from "./quan.vue?vue&type=style&index=0&id=db2ca6c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2ca6c4",
  null
  
)

export default component.exports